module.exports = __webpack_public_path__ + "static/media/viveport.1a29ac42.png";